import { createSelector } from 'reselect';

export const selectCanBeImpersonatedBy = createSelector(({ teamsManagement }) => teamsManagement.canBeImpersonatedBy, result => result);

export const selectCanImpersonate = createSelector(({ teamsManagement }) => teamsManagement.canImpersonate, result => result);
